<mat-icon class="dialog__close" mat-icon-button (click)="closeBottomsheet($event)">close</mat-icon>

<section class="dialog">
  <header class="grid-noGutter-spaceBetween-middle">
    <div class="col-12 grid-noGutter-middle-left dialog__title">
      <h1>{{ data.title }}</h1>
    </div>
  </header>

  <section class="dialog__container" [ngStyle]="{ height: data['scrollableHeight'] }">
    <ng-container *ngFor="let item of data.actions">
      <div
        class="dialog__container__options flex-row"
        matRipple
        (click)="performAction(item)"
        [ngStyle]="{ opacity: item.disabled ? '0.4' : '1' }"
        *ngIf="!item.disabled"
      >
        <div class="dialog__container__options__icon">
          <mat-icon [ngClass]="{ 'icon-outlined': item.outlined }">{{ item.icon }}</mat-icon>
        </div>
        <div class="dialog__container__options__label">{{ item.label | translate }}</div>
      </div>
    </ng-container>
  </section>
</section>
